import type { LoadingStatusStateType } from '../../LoadingStatus';

export type errorMapForOrderStateType = {|
  key: $Keys<LoadingStatusStateType>,
  type: {|
    FAILED?: {|
      title?: ?string,
      text?: ?string,
    |},
    IN_PROGRESS?: {|
      title?: ?string,
      text?: ?string,
    |},
  |},
|};

type errorState = 'FAILED' | 'IN_PROGRESS';

export const getErrorToast = (state: errorState, errorMapForOrderState: ?errorMapForOrderStateType): ?string => {
  if (!errorMapForOrderState) return null;
  const error = errorMapForOrderState.type[state];
  return error && (error.title || error.text);
};
